import React, { useLayoutEffect, useReducer, useRef } from 'react';
import * as d3 from 'd3';
import produce from 'immer';
import useSound from 'use-sound';

import CircularBoard from '../../assets/circular-board.svg';
import RedBall from '../../assets/red-ball.svg';
import RedBallInverted from '../../assets/red-ball-inverted.svg';
import OrangeBall from '../../assets/orange-ball.svg';
import OrangeBallInverted from '../../assets/orange-ball-inverted.svg';
import YellowBall from '../../assets/yellow-ball.svg';
import YellowBallInverted from '../../assets/yellow-ball-inverted.svg';
import GreenBall from '../../assets/green-ball.svg';
import GreenBallInverted from '../../assets/green-ball-inverted.svg';
import BlueBall from '../../assets/blue-ball.svg';
import BlueBallInverted from '../../assets/blue-ball-inverted.svg';

const ROWS_DEF = [
  {
    x0: 210,
    xSpacing: 118,
    y0: 80,
    ball: RedBall,
    invertedBall: RedBallInverted,
    items: [
      ['A', false],
      ['B', false],
      ['C', false],
      ['D', false],
      ['E', false],
    ],
  },
  {
    x0: 100,
    xSpacing: 118,
    y0: 248,
    ball: OrangeBall,
    invertedBall: OrangeBallInverted,
    items: [
      ['', false],
      ['F', false],
      ['G', false],
      ['H', false],
      ['I', false],
      ['J', false],
      ['', false],
    ],
  },
  {
    x0: 10,
    xSpacing: 110,
    y0: 450,
    ball: YellowBall,
    invertedBall: YellowBallInverted,
    items: [
      ['', false],
      ['K', false],
      ['L', false],
      ['M', false],
      ['N', false],
      ['O', false],
      ['P', false],
      ['Q', false],
      ['', false],
    ],
  },
  {
    x0: 60,
    xSpacing: 111,
    y0: 650,
    ball: GreenBall,
    invertedBall: GreenBallInverted,
    items: [
      ['', false],
      ['R', false],
      ['S', false],
      ['T', false],
      ['U', false],
      ['V', false],
      ['W', false],
      ['', false],
    ],
  },
  {
    x0: 210,
    xSpacing: 118,
    y0: 816,
    ball: BlueBall,
    invertedBall: BlueBallInverted,
    items: [
      ['', false],
      ['X', false],
      ['Y', false],
      ['Z', false],
      ['', false],
    ],
  },
];

const ACTION_TYPE_POP_IT = 'ACTION_POP_IT';

const reducer = (state, action) => {
  if (action.type === ACTION_TYPE_POP_IT) {
    const { row, col } = action.payload;
    return produce(state, draft => {
      draft[row].items[col][1] = true;
    });
  }

  return state;
};

const DRAWING_WIDTH = 1000;

const Alphabet = ({ bounds, interactive = true }) => {
  const containerRef = useRef(null);
  const [state, dispatch] = useReducer(reducer, ROWS_DEF);
  const [playPopSound] = useSound('/pop_sound.mp3');

  const diameter = Math.min(bounds.width, bounds.height);

  useLayoutEffect(() => {
    const FINAL_WIDTH = diameter;

    const ref0 = d3.select(containerRef.current).select('g');
    ref0.selectAll('*').remove();

    const ref = ref0.append('g');

    ref.attr('width', DRAWING_WIDTH).attr('height', DRAWING_WIDTH);

    ref.append('image').attr('xlink:href', CircularBoard);

    state.forEach(({ ball, invertedBall, items, x0, y0, xSpacing }, row) => {
      items.forEach(([letter, isPopped], col) => {
        const group = ref.append('g').attr('transform', `translate(${x0 + xSpacing * col},${y0})`);

        if (interactive) {
          group.style('cursor', 'pointer').on('click', () => {
            // alert(`${row}, ${col}`);
            if (!isPopped) playPopSound();

            dispatch({ type: ACTION_TYPE_POP_IT, payload: { row, col } });
          });
        }

        group.append('image').attr('xlink:href', isPopped ? invertedBall : ball);

        group
          .append('text')
          .attr('x', 50)
          .attr('y', 55)
          .text(letter)
          .attr('font-family', 'Roboto')
          .attr('font-size', '60px')
          .attr('dy', '0.35em')
          .style('text-anchor', 'middle')
          .style('opacity', isPopped ? 0.8 : 1);
      });
    });

    // .attr('height', 400);

    const scale = FINAL_WIDTH / DRAWING_WIDTH;
    ref.attr('transform', `scale(${scale},${scale})`);

    return () => ref0.selectAll('*').remove();
  }, [state, playPopSound, diameter, interactive]);

  return (
    <svg width={diameter} height={diameter} ref={containerRef}>
      <g transform="translate(0,0)" />
    </svg>
  );
};

Alphabet.propTypes = {};

export default Alphabet;
